<div class="portfolio-chart">
  <!-- Chart stays mounted and updates in place (no *ngIf swap) — destroying it
       mid-navigator-drag crashes Highcharts' pointer handler. Spinner overlays. -->
  <app-navigator-chart
    [chartData]="chartData"
    [navigatorData]="navigatorData"
    [valueMode]="valueMode"
    [theme]="theme"
    [maxRangeMs]="maxRangeMs"
    (extremesChange)="onExtremesChange($event)"
  ></app-navigator-chart>
  <div class="loading" *ngIf="loading">
    <mat-spinner [diameter]="50"></mat-spinner>
  </div>
</div>
